import React from 'react';

/**
 * Reusable editable input component for inline value editing
 */
const EditableInput = ({
  value,
  isEditing,
  tempValue,
  onEdit,
  onChange,
  onSubmit,
  onCancel,
  onKeyDown,
  onBlur,
  min,
  max,
  step,
  className = "gm-inline-input"
}) => {
  if (isEditing) {
    return (
      <input
        type="number"
        value={tempValue}
        onChange={(e) => onChange(e.target.value)}
        onKeyDown={onKeyDown}
        onBlur={onBlur}
        onFocus={(e) => e.target.select()}
        className={className}
        autoFocus
        min={min}
        max={max}
        step={step}
      />
    );
  }

  return (
    <span
      className="gm-trade-value"
      onClick={onEdit}
    >
      {value}
    </span>
  );
};

export default EditableInput;
